// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTechnologyBlockCloud = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.402 18v-.006l2.035.006h.003a3.563 3.563 0 0 0 1.728-6.678l-.968-.54a.2.2 0 0 1-.102-.183l.046-1.108c.002-.036.002-.073.002-.11a2.573 2.573 0 0 0-3.692-2.32l-1.08.524a.2.2 0 0 1-.219-.03l-.898-.796a5.347 5.347 0 0 0-8.865 3.506l-.078.852a.2.2 0 0 1-.088.148l-.71.477A3.418 3.418 0 0 0 5.4 18h.008zm2 2H5.39a5.418 5.418 0 0 1-2.99-9.918 7.347 7.347 0 0 1 12.182-4.82 4.573 4.573 0 0 1 6.56 4.313A5.563 5.563 0 0 1 18.472 20h-.036zm-8.288-9.382a2.668 2.668 0 0 0-.412 3.24l3.653-3.652a2.668 2.668 0 0 0-3.24.412zm4.184.531-3.653 3.653a2.668 2.668 0 0 0 3.653-3.653zM9.172 9.675a4 4 0 1 1 5.656 5.657 4 4 0 0 1-5.656-5.657z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTechnologyBlockCloud;
